import axios from 'axios';

// Set up axios defaults
const resolvedApiUrl = (() => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (process.env.NODE_ENV === 'development') {
    // Use CRA dev-server proxy in development.
    return '/';
  }

  // REACT_APP_API_URL must be set at build time for production builds.
  // Falling back to a relative origin prevents mixed-content HTTPS errors.
  return window.location.origin;
})();

const baseURL = resolvedApiUrl;
axios.defaults.baseURL = baseURL.endsWith('/') ? baseURL.slice(0, -1) : baseURL;

// Add request interceptor to include token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;